import { render, staticRenderFns } from "./ServiceWorkflow.vue?vue&type=template&id=451ef9c0&scoped=true"
import script from "./ServiceWorkflow.vue?vue&type=script&lang=js"
export * from "./ServiceWorkflow.vue?vue&type=script&lang=js"
import style0 from "./ServiceWorkflow.vue?vue&type=style&index=0&id=451ef9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ef9c0",
  null
  
)

export default component.exports